<h2>{{viewContext.entityNamePlural | titlecase}}</h2>

<app-array [entities]="entities"
           [listColumns]="getListColumns()"
           [selectedEntity]="selectedEntity"
           (rowOpenRequire)="openCurrentEntityInForm($event)"
           (rowSelected)="onSelect($event)"
           [entityOrder]="entityOrder"
           (headerClicked)="onHeaderClicked($event)"
           (rowDeleteRequire)="openEntityInDeleteDialog($event)"
           [isShortcutsInUse]="!isOpenViewsOpen()"
>
</app-array>

<app-buttons [buttons]="getButtonsMeta()"
             (buttonPressed)="controlButtonPressed($event)"
             [targetSelected]="!!selectedEntity">
</app-buttons>
